import { EEventManagementTabsType } from '@src/common/constant/enum';

const path = `/management`;

export const managementRouteMap: Record<EEventManagementTabsType, string> = {
  [EEventManagementTabsType.METRICS]: `${path}/metrics`,
  [EEventManagementTabsType.CUSTOM_DIMENSION]: `${path}/custom-dimension`,
  [EEventManagementTabsType.MAPPED_EVENT]: `${path}/mapped-events`,
  [EEventManagementTabsType.KPI_SETTING]: `${path}/bad-events`,
  [EEventManagementTabsType.FLOWS]: `${path}/flows`,
};
